export const separateRoles = (investigators) => {
  let ips = investigators
    .filter(({ otroRole }) => otroRole === "ip")
    .map(({ staff }) => staff);
  let participants = investigators
    .filter(({ otroRole }) => otroRole === "participant")
    .map(({ staff }) => staff);
  return { ips: cleanUsers(ips), participants: cleanUsers(participants) };
};

export const cleanUsers = (users) => {
  let cleanedUsers = [];
  users.map(({ id, nombre, apellidos }) =>
    cleanedUsers.push({ id, nombre, apellidos })
  );
  return cleanedUsers;
};

export const uniqueUsers = (set1, set2) =>
  [].concat(
    set1?.filter((set) => set2.every(({ id }) => set.id !== id)),
    set2.filter((set) => set1?.every(({ id }) => set.id !== id))
  );

export const buildInvestigatorOtro = (participants, ips, otroId) => {
  participants = participants.map(({ id }) => ({
    otroRole: "PARTICIPANT",
    staffId: id,
    otroId,
  }));
  ips = ips.map(({ id }) => ({
    otroRole: "ip",
    staffId: id,
    otroId,
  }));
  return participants.concat(ips);
};
